export const DAM_PARENT_PATH: string = 'DAM_PARENT_PATH'
export const DAM_PARENT_FULL_PATH: string = 'DAM_PARENT_FULL_PATH'
export const DAM_ASSETS_TYPE: string = 'DAM_ASSETS_TYPE'
